import PropTypes from 'prop-types';
import { Fragment } from 'react';

import resolveRelationships from 'core/utils/relationships';
import modelPropTypes, { topicAttributes } from 'core/utils/prop-types/model';
import themePropTypes from 'core/utils/prop-types/theme';
import { withRouter } from 'react-router';
import { shouldShowPhotoSource } from 'core/utils/content';

import withTheme from 'core/hocs/withTheme';
import SocialMedia from 'core/components/SocialMedia';
import TopicTags from 'core/components/TopicTags';
import Authors from 'core/components/Topic/Authors';
import { Indent } from 'core/components/Wrappers';
import Reactions, { PARENT_TYPE_MAP } from 'core/components/Reactions';
import EmojiBar from 'core/components/Reactions/EmojiBar';
import EmojiBarLoader from 'core/components/Reactions/EmojiBar/Loader';
import RamblerVideo from 'core/components/Video/RamblerVideo';

import Source from './Source';
import CommentButton from './CommentButton';

import styles from './index.styl';

const relationships = resolveRelationships(...[
  ['tags', 'authors', 'social_network', 'emoji_bar', 'video_explainer'],
  {},
  { tags: [], social_network: {} },
]);

function TopicFooter(props) {
  const {
    content,
    hrefBuilder,
    hideTopicTags,
    disableComments,
    disableAuthors,
    disableSource,
    location: {
      pathname,
    },
    theme: {
      controls: {
        topicFooter: {
          socialMedia: {
            type,
          },
          block: {
            interitemSpacing,
            spacing,
          },
        },
      },
    },
    CustomSocialMedia,
  } = props;

  if (!content) return null;

  const {
    id,
    attributes: {
      link,
      topic_type: topicType,
      is_comments_disabled: isCommentsDisabled,
      source,
      source_url: sourceUrl,
      photo_source: photoSource,
      photo_source_url: photoSourceUrl,
      published_at: publishedAt,
    },
  } = content;

  const showPhotoSource = shouldShowPhotoSource(publishedAt);

  const {
    tags,
    authors,
    social_network: socialNetwork,
    emoji_bar: emojiBar,
    video_explainer: {
      vp_video_id: videoExplainerId,
    },
  } = relationships(content);

  const isCommentPage = /\/comments$/i.test(pathname);

  return (
    <Fragment>
      <style jsx>{`
        .${styles.item}
          & + &
            margin-top ${interitemSpacing}px
      `}</style>
      <Indent top={spacing} />
      <div className={styles.content}>
        {!disableComments && !isCommentsDisabled && !isCommentPage && (
          <CommentButton
            className={styles.commentsButton}
            xid={id}
            commentsUrl={`${link}/comments`}
          />
        )}
        <div className={styles.list}>
          {!!photoSource && showPhotoSource && (
            <div className={styles.item}>
              <Source title='Источник фото:' sourceUrl={photoSourceUrl} >
                {photoSource}
              </Source>
            </div>
          )}
          {!disableSource && !!source && (
            <div className={styles.item}>
              <Source title='Источник:' sourceUrl={sourceUrl} >
                {source}
              </Source>
            </div>
          )}
          {!disableAuthors && authors.length > 0 && (
            <div className={styles.item}>
              <Authors authors={authors} />
            </div>
          )}
          {!hideTopicTags && tags.length > 0 && (
            <div className={styles.item}>
              <TopicTags
                data={tags}
                hrefBuilder={hrefBuilder}
              />
            </div>
          )}
        </div>
      </div>
      {!!socialNetwork.slug && (
        <Indent top={spacing}>
          {CustomSocialMedia ?
            <CustomSocialMedia
              socialNetwork={socialNetwork}
              type={type}
            /> :
            <SocialMedia
              socialNetwork={socialNetwork}
              type={type}
            />}
        </Indent>
      )}
      {!!emojiBar.enabled && (
        <Indent top={spacing}>
          <Reactions
            targetType='Plugins::EmojiBar'
            parentType={PARENT_TYPE_MAP[topicType]}
            pageType='topics'
            targetId={id}
            controls={EmojiBar}
            customLoader={EmojiBarLoader}
          />
        </Indent>
      )}
      {videoExplainerId && (
        <Indent top={spacing}>
          <RamblerVideo videoId={videoExplainerId} />
        </Indent>
      )}
    </Fragment>
  );
}

TopicFooter.propTypes = {
  content: modelPropTypes(topicAttributes),
  isDesktop: PropTypes.bool,
  hrefBuilder: PropTypes.func,
  hideTopicTags: PropTypes.bool,
  disableComments: PropTypes.bool,
  disableAuthors: PropTypes.bool,
  disableSource: PropTypes.bool,
  location: PropTypes.object,
  CustomSocialMedia: PropTypes.node,
  theme: themePropTypes(`{
    controls: {
      topicFooter: {
        socialMedia: {
          type,
        },
        block: {
          interitemSpacing,
          spacing,
        },
      }
    }
  }`),
};

export default withTheme(withRouter(TopicFooter));
